import { Components, Theme } from "@mui/material/styles";

export const MuiCircularProgress: Components<Theme>["MuiCircularProgress"] = {
    defaultProps: {
        thickness: 4,
        size: 40,
    },
};
